import {
  Component,
  OnInit,
  AfterViewChecked,
  ChangeDetectorRef
} from "@angular/core";
import {
  trigger,
  state,
  style,
  transition,
  animate
} from "@angular/animations";
import { Meta, Title } from "@angular/platform-browser";

@Component({
  selector: "app-landing",
  templateUrl: "./landing.component.html",
  styleUrls: ["./landing.component.scss"],
  animations: [
    trigger("fadeInAnimation", [
      state(
        "start",
        style({
          transform: "scale(1.1)",
          opacity: 0
        })
      ),
      state(
        "end",
        style({
          transform: "scale(1)",
          opacity: 1
        })
      ),
      transition("start => end", animate("1500ms ease-in-out"))
    ]),

    trigger("takeLookAnimation", [
      state(
        "start",
        style({
          height: 0
        })
      ),
      state(
        "end",
        style({
          height: 46
        })
      ),
      state("loop", style({}))
    ])
  ]
})
export class LandingComponent implements OnInit, AfterViewChecked {
  public rodAssets = {
    heroImage: "./assets/home/rodrigos-mexican-grill-tostada.jpg",
    logo: "./assets/global/rodrigos-mexican-grill-logo-white.png"
  };

  public psaActive: boolean = false;

  public heroSlidesConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    dots: false,
    mobileFirst: false,
    centerMode: false,
    centerPadding: "0",
  };

  public heroSlides = [
    {
      img: './assets/home/Asada_Carousel.jpg',
      caption: 'Carne Asada',
      link: '',
      title: '',
      width: '2002',
      height: '1126',
    },
    {
      img: './assets/home/Combo_Carousel.jpg',
      caption: '',
      link: '',
      title: '',
      width: '2002',
      height: '1126',
    },
    {
      img: './assets/home/Fajitas_Carousel.jpg',
      caption: '',
      link: '',
      title: '',
      width: '2002',
      height: '1126',
    },
    {
      img: './assets/home/Reserve_Your_Fiesta_01062023.JPG',
      caption: 'Reserve your Fiesta Party',
      link: '/hours-locations',
      title: '',
      width: '2002',
      height: '1126',
    },
    {
      img: "./assets/home/Mobile_App_2002x1126.jpg",
      caption: "Download our Mobile App",
      link: "/mobile-app",
      title: '',
      width: '2002',
      height: '1126',
    },
    {
      img: "./assets/home/rodrigos-mexican-grill-tostada.jpg",
      caption: "",
      link: "",
      title: '',
      width: '2002',
      height: '1126',
    }
  ];

  public slides = [
    {
      img: "./assets/gallery/carne-asada.jpg",
      caption: "Carne Asada",
      descriptionBackground: "./assets/menu/item-description-bg-red.png",
      color: "#7b1609",
      width: '1600',
      height: '800',
    },
    {
      img: "./assets/gallery/two-item-combo.jpg",
      caption: "Two Item Combo",
      descriptionBackground: "./assets/menu/item-description-bg-yellow.png",
      color: "#ad870e",
      width: '1600',
      height: '800',
    },
    {
      img: "./assets/gallery/tacos.jpg",
      caption: "Street Tacos",
      descriptionBackground: "./assets/menu/item-description-bg-teal.png",
      color: "#134048",
      width: '1600',
      height: '800',
    },
    {
      img: "./assets/gallery/flan.jpg",
      caption: "Birthday Flan",
      descriptionBackground: "./assets/menu/item-description-bg-green.png",
      color: "#384500",
      width: '1600',
      height: '800',
    },
    {
      img: "./assets/gallery/enchilada.jpg",
      caption: "Enchiladas",
      descriptionBackground: "./assets/menu/item-description-bg-red.png",
      color: "#7b1609",
      width: '1600',
      height: '800',
    }
  ];

  public slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    dots: false,
    mobileFirst: false,
    centerMode: false,
    centerPadding: "0",
  };

  public state: string = "start";

  public slider;

  constructor(private cdRef: ChangeDetectorRef, title: Title, meta: Meta) {

    // If [date] is still in the future, add slides
    // if(new Date("May 6, 2026 00:00:00 GMT-08:00").valueOf() - Date.now() > 1) {
    //   this.heroSlides.unshift(
    //     {
    //       img: './assets/home/rodrigos-cinco-de-may-meets-taco-tuesday.jpg',
    //       caption: 'A promotional banner for Rodrigo\'s Mexican Grill featuring a woman in a traditional folk dance dress and a man in charro attire playing guitar. The text reads "Cinco de Mayo Meets Taco Tuesday, May 5" with a "Make a Reservation" button.',
    //       link: '/reservations',
    //       title: 'Rodrigo\'s Cinco de Mayo Meets Taco Tuesday Celebration!',
    //     }
    //   );
    // }

    this.heroSlides.unshift(
      {
        img: './assets/home/taco-tuesday-banner.png',
        caption: 'A promotional graphic banner featuring a textured black background with red accents celebrating Taco Tuesday. The left side features a stylized "Taco Tuesday All Day" logo beneath a small red taco line-art drawing. The right side lists deals for "1/2 OFF TACOS" and "$6.00 HOUSE MARGARITAS" above the tagline "TACOS. MARGARITAS. REPEAT."',
        title: 'Taco Tuesday All Day Restaurant Specials',
        link: '',
        width: '1672',
        height: '941',
      }
    );

    // If [date] is still in the future, add slides
    if(0 < new Date("June 22, 2026 00:00:00 GMT-07:00").valueOf() - Date.now()) {
      this.heroSlides.unshift(
        {
          img: './assets/home/fathers-day-hero-banner.jpg',
          caption: 'A Father\'s Day promotional banner featuring a father laughing with his two children over a meal of sizzling fajitas and margaritas. The text reads "Dads Deserve a Great Time - Father\'s Day Sunday, June 21" with a call to "Reserve a Table With Your Dad Today."',
          title: 'Father\'s Day Reservations at Rodrigo\'s Mexican Grill',
          link: '/reservations',
          width: '1920',
          height: '1080',
        }
      );
    }

    // If [date] is between...
    if(0 > new Date("May 18, 2026 00:00:00 GMT-07:00").valueOf() - Date.now() && 0 < new Date("June 15, 2026 00:00:00 GMT-07:00").valueOf() - Date.now()) {
      this.heroSlides.unshift(
        {
          img: './assets/home/graduation-25-promo.jpg',
          caption: 'Promotional banner for Graduation Season offering 25% off party platters and 3-foot burritos. The image shows a large black catering tray filled with tacos, taquitos, burritos, and chicken wings, with an "Order Now" button.',
          title: 'Graduation Season Deal: 25% Off Party Platters',
          link: '/reservations',
          width: '1672',
          height: '941',
        }
      );
    }

    // If [date] is between...
    if(0 < new Date("July 24, 2026 22:00:00 GMT-07:00").valueOf() - Date.now()) {
      this.heroSlides.unshift(
        {
          img: './assets/home/national-tequila-day-hero-web.jpg',
          caption: 'Promotional website banner for National Tequila Day on Friday, July 24. Displays a chili-rimmed shot and cocktails with text offering $2.00 off all margaritas and $4.00 Mexican candy shots.',
          title: 'National Tequila Day Specials and Discounts',
          link: '',
          width: '1920',
          height: '1080',
        }
      );
    }

    title.setTitle(
      "Rodrigo’s Mexican Grill | Authentic Mexican Food in Santa Ana, Orange and more"
    );

    // meta.addTags([
    //   { name: "author", content: "Rodrigos.com" },
    //   {
    //     name: "keywords",
    //     content:
    //       "Mexican food, Tustin, Temecula, Corona, Taco Tuesday, brunch, happy hour, margaritas, Mexican restaurant, dine-in, takeout"
    //   },
    //   {
    //     name: "description",
    //     content:
    //       "Rodrigo’s Mexican Grill serves the best Mexican food in Tustin, Temecula, Corona, Santa Ana, Orange & more. Join us for Taco Tuesday, brunch, happy hour, and margaritas."
    //   }
    // ]);
  }

  ngOnInit() {}

  ngAfterViewChecked() {
    this.state = "end";
    this.cdRef.detectChanges();
  }

  closePromo() {
    this.psaActive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/landing/landing.component.ts